import { render, staticRenderFns } from "./ManagementViewDialog.vue?vue&type=template&id=0bc37144&scoped=true"
import script from "./ManagementViewDialog.vue?vue&type=script&lang=js"
export * from "./ManagementViewDialog.vue?vue&type=script&lang=js"
import style0 from "./ManagementViewDialog.vue?vue&type=style&index=0&id=0bc37144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc37144",
  null
  
)

export default component.exports